import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private dataService: DataService, private router: Router) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = this.dataService.getToken();
    const user = this.dataService.getUser();
    if (token && !this.dataService.isTokenExpired(token) && user) {
      return true;
    }
    this.dataService.logout();
    this.router.navigate(['/tabs/signin'], { queryParams: { redirect: state.url } });
    return false;
  }
  
}
